import React from 'react'
import { Column, WidgetCell } from '@sencha/ext-modern'
import LineProcessing2 from '../../base/LineProcessing2'

const render = ({ _lineProcessing2: text, dataIndex, edit, handleEdit, styles, ...rest }) => {
	const renderInner = (value, record, dataIndex, cell, column) => {
		const { config: { minHeight, maxHeight, tooltipDelay, wrapperStyle } = {} } = column || {}
		// value = genHtml(value)

		const style = { ...wrapperStyle || {}/* width: '100%', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', display: 'flex', flexDirection: 'column'  */ }
		maxHeight && (style.maxHeight = `${maxHeight}px`)
		minHeight && (style.minHeight = `${minHeight}px`)

		return <div className='t-grid-lineprocessing2'><LineProcessing2 {...{ value, styles }} /></div>
	}

	// console.log('render lineProcessing2:', edit)
	return <Column {...{ dataIndex, text, renderer: renderInner, ...rest }} />
}

export default render